import { createAction, handleActions } from 'redux-actions'

/////////////////
//// Actions ////
/////////////////

const BASE_ACTION_NAME = 'auth'

export const TYPE_NAME = createAction(`${BASE_ACTION_NAME}/type_name`)

export const CREATE_USER = createAction(`${BASE_ACTION_NAME}/create_participant`)
export const CREATE_USER_SUCCESS = createAction(`${BASE_ACTION_NAME}/create_participant/success`)
export const CREATE_USER_FAILURE = createAction(`${BASE_ACTION_NAME}/create_participant/failure`)

/////////////////
//// Reducer ////
/////////////////

const initialState = {
  name: '',
  isLoading: false
}

export default handleActions(
  {
    [TYPE_NAME]: (state, action) => ({
      ...state,
      name: action.payload
    }),

    [CREATE_USER]: state => ({
      ...state,
      isLoading: true
    }),

    [CREATE_USER_SUCCESS]: state => ({
      ...state,
      isLoading: false
    }),

    [CREATE_USER_FAILURE]: state => ({
      ...state,
      isLoading: false
    })
  },
  initialState
)
